// @flow

// Libraries
import * as React from 'react';
import { useSelector } from 'react-redux';
import { v4 as uuid4 } from 'uuid';
import { get, findIndex, find } from 'lodash';
import classNames from 'classnames';

// Components
import { Card as BaseCard } from '@components/Card';

// Styles
import styles from './Pagination.scss';
import { useMemo } from 'react';

// Types
type PropTypes = {
  page?: Object,
  pages?: [Object]
}

function reorderPagesByTabs(tabs, pages) {
  const filteredTabs = tabs.filter(Boolean);

  if (!filteredTabs || !pages || pages.length === 0) {
    return pages;
  }

  const reordered = [];

  filteredTabs.forEach(tab => {
    const tabPages = pages.filter(page => page.tab === tab.title);
    reordered.push(...tabPages);
  });

  return reordered;
}

const Pagination = ({ page, pages }: PropTypes) => {
  const isLogin = useSelector(state => !!get(state, 'session.token', false));
  const { tabs } = useSelector(state => find(get(state, 'boards.list.sys.pages'), { name: 'main_banner' }));

  const reorderedPages = useMemo(() => reorderPagesByTabs(tabs, pages), [pages, tabs]);

  const pageIndex = findIndex(reorderedPages.filter(p => !isLogin ? p.isExternal : p), { id: get(page, 'id') });
  const prevPage = get(reorderedPages.filter(p => !isLogin ? p.isExternal : p), `[${pageIndex - 1}]`);
  const nextPage = get(reorderedPages.filter(p => !isLogin ? p.isExternal : p), `[${pageIndex + 1}]`);

  return (
    <div className={styles.Root}>
      {
        [
          prevPage,
          nextPage
        ].map((item, index) => (
          <BaseCard
            key={uuid4()}
            classes={{
              root: classNames(
                styles.CardRoot,
                {
                  [styles.CardRootDisabled]: !item,
                  [styles.CardRootPrevious]: !index,
                  [styles.CardRootNext]: index
                }
              ),
              title: styles.CardTitle,
              additional: styles.CardAdditional,
              content: styles.CardContent,
              description: styles.CardDescription,
              media: styles.CardMedia,
            }}
            variant="horisontal"
            type="link"
            mode="read"
            data={{
              ...item,
              additional: index > 0 ? 'Next page' : 'Previous page'
            }}
          />
        ))
      }
    </div>
  )
};

export default Pagination;
